import { render, staticRenderFns } from "./Correct.vue?vue&type=template&id=6fc2551b"
import script from "./Correct.vue?vue&type=script&lang=js"
export * from "./Correct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports